import { Pipe, PipeTransform } from '@angular/core';
import { Task } from './models/task';

@Pipe({
  name: 'keepLatestUniqueInstanceWithName'
})
export class KeepLatestUniqueInstanceWithNamePipe implements PipeTransform {
  transform(values: Task[] | null): Task[] {
    if (!values) {
      return [];
    }

    const uniqueNames = new Set();
    const latestTasks = values
      .slice()
      .reverse()
      .filter((task) => {
        if (uniqueNames.has(task.shortname)) {
          return false;
        }
        uniqueNames.add(task.shortname);

        return true;
      });

    return latestTasks.reverse();
  }
}
